'use strict';

module.exports = {generator: require('./generator.js'), scanner: require('./scanner.js')};